"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormModelEdit = exports.FormModel = exports.FormModelMutator = void 0;
const id_1 = require("../../id");
const form_metadata_1 = require("./form.metadata");
const form_state_1 = require("./form.state");
const form_subform_1 = require("./form.subform");
class FormModelMutator extends form_subform_1.FormModelMutatorSubForm {
    displayName(displayName) {
        this.state.setDisplayName(displayName);
    }
    description(description) {
        this.state.setDescription(description);
    }
}
exports.FormModelMutator = FormModelMutator;
class FormModel extends form_subform_1.FormModelFieldSubForm {
    get state() {
        return this._state = this._state || new form_state_1.FormModelState(this);
    }
    get Mutator() {
        if (this._FMutator == null) {
            this._FMutator = new FormModelMutator(this);
        }
        return this._FMutator;
    }
    get id() { return this.state.id; }
    set id(v) { this.state.id = v; }
    get revision() { return this.state.revision; }
    set revision(v) { this.state.revision = v; }
    get version() { return this.state.version; }
    set version(v) { this.state.version = v; }
    get rootFormId() { return this.state.rootFormId; }
    set rootFormId(v) { this.state.rootFormId = v; }
    get name() { return this.state.name; }
    set name(v) { this.state.name = v; }
    get description() { return this.state.description; }
    set description(v) { this.state.description = v; }
    get displayName() { return this.state.displayName; }
    set displayName(v) { this.state.displayName = v; }
    get displayVersion() { return this._displayVersion; }
    set displayVersion(v) { this._displayVersion = v; }
    get updatedAt() { return this.state.updatedAt; }
    set updatedAt(v) { this.state.updatedAt = v; }
    get createdAt() { return this.state.createdAt; }
    set createdAt(v) { this.state.createdAt = v; }
    get updatedBy() { return this.state.updatedBy; }
    set updatedBy(v) { this.state.updatedBy = v; }
    get metadata() { return this.state.metadata; }
    set metadata(v) { this.state.metadata = v; }
    constructor() {
        super(null, null);
        this._state = new form_state_1.FormModelState(this);
        this.revision = id_1.IkeId.generate();
        this.version = this.revision;
        this.rootFormId = this.revision;
        this.metadata = new form_metadata_1.FormModelMetadata(this);
    }
    getForm() {
        return this;
    }
    get stateValue() {
        const fieldState = this.state.getFieldValue(this.fieldId) || { fields: [] };
        return {
            id: this.id,
            displayName: this.state.displayName,
            fields: fieldState.fields,
            label: null,
            type: 'form'
        };
    }
}
exports.FormModel = FormModel;
class FormModelEdit extends FormModel {
    constructor(form, state) {
        super();
        this.formModel = form;
        this.revision = form.revision;
        this._state = state;
    }
}
exports.FormModelEdit = FormModelEdit;
//# sourceMappingURL=form.js.map